module.exports = __webpack_public_path__ + "img/publisher.fdade8a9.svg";